import { Component } from '@angular/core';
import {ScreenService} from "../../../services";
import {BaseComponent} from "../base/base.component";

@Component({
  selector: 'app-base-list',
  template: ``
})
export class BaseListComponent extends BaseComponent {
  mobileMode: boolean = false;
  constructor(private screenService: ScreenService) {
    super();

    screenService.changed.subscribe(() => this.setMobileMode());

    this.setMobileMode();
  }

  setMobileMode() {
    this.mobileMode = this.screenService.sizes['screen-x-small'];
  }
}
